import DebugComponents from '../constants/debugComponents';
import UserPermissions from '../constants/userPermissions';
import { PermissionRules } from '../usePermissions';

type debugComponentRegistry = {
  [name in DebugComponents]: PermissionRules;
};

const DebugComponentRegistry: debugComponentRegistry = {
  DebugFrame: {
    [UserPermissions.CLOSE_SUPPORT_SESSION]: true,
  },
  DebugOrganizationModal: {
    [UserPermissions.START_SUPPORT_SESSION]: true,
  },
  DebugOrganizationConfirmationModal: {
    [UserPermissions.START_SUPPORT_SESSION]: true,
  },
};

export default DebugComponentRegistry;
